/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { Switch, Redirect } from 'react-router-dom';
import { toAbsoluteUrl } from '../../../../_metronic/_helpers';
import { ContentRoute } from '../../../../_metronic/layout';
import Login from './Login';
import Registration from './Registration';
import ForgotPassword from './ForgotPassword';
import '../../../../_metronic/_assets/sass/pages/login/classic/login-1.scss';
import ConfirmUser from './ConfirmUser';

const date = new Date().getFullYear();

export function AuthPage() {
  const images = ['/media/bg/senseworks-1.jpg', '/media/bg/senseworks-2.jpg'];

  const selectedImage = images[Math.round(Math.random())];

  return (
    <>
      <div className="d-flex flex-column flex-root">
        {/*begin::Login*/}
        <div
          className="login login-1 login-signin-on d-flex flex-column flex-lg-row flex-column-fluid bg-white"
          id="kt_login"
        >
          {/*begin::Aside*/}
          <div
            className="login-aside d-flex flex-row-auto bgi-size-cover bgi-position-center bgi-no-repeat p-10 p-lg-10"
            style={{
              backgroundImage: `url(${toAbsoluteUrl(selectedImage)})`,
            }}
          ></div>
          {/*begin::Content*/}
          <div className="d-flex flex-column flex-row-fluid position-relative p-7 overflow-hidden">
            {/* begin::Content body */}
            <div className="text-center mt-10 mt-lg-20">
              <img
                src={toAbsoluteUrl('/media/logos/logo-login.png')}
                width="300px"
                height="100px"
                alt="SenseWorks"
              />
              <h5 className="mt-2 menu-item">Cloud Management Console</h5>
            </div>
            <div className="d-flex flex-column-fluid flex-center mt-20 mt-lg-0">
              <Switch>
                <ContentRoute path="/auth/login" component={Login} />
                <ContentRoute
                  path="/auth/registration"
                  component={Registration}
                />
                <ContentRoute
                  path="/auth/forgot-password"
                  component={ForgotPassword}
                />
                <ContentRoute path="/auth/confirm" component={ConfirmUser} />
                <Redirect from="/auth" exact={true} to="/auth/login" />
                <Redirect to="/auth/login" />
              </Switch>
            </div>
            <div className="flex-column-auto d-lg-flex justify-content-between mt-10">
              <span className="text-muted">
                {date} © SenseWorks Tecnologia Ltda. All rights reserved.
              </span>
            </div>
            {/*end::Content body*/}
          </div>
          {/*end::Content*/}
        </div>
        {/*end::Login*/}
      </div>
    </>
  );
}
